module.exports = __webpack_public_path__ + "img/icon-favorito-selected.ef6a5bc1.svg";